import {doc} from './docs.js';
import {BANG, START, TICK} from 'messaging/message-types.js';

doc(
    "record.messages",
    {
        "messages": "",
    },
    "Records incoming messages starting from when the record is engaged"
);
export const recordMessages = (object) => {
    object.needsTick = true;
    let lastStepNumber;
    let isRecording = false;
    let recorded = [];
    let startStepNumber = 0;
    let lastUnrecordedMessage;

    const record = () => {
        startStepNumber = lastStepNumber;
        if (lastUnrecordedMessage) {
            recorded = [[0, lastUnrecordedMessage]];
        } else {
            recorded = [];
        }
        isRecording = true;
    };

    return ([msg, ...args]) => {
        switch (msg) {
        case START:
            return;
        case TICK:
            let [time] = args;
            lastStepNumber = object.sequencerEngine.trackStep;
            return;
        default:
            recorded.push([lastStepNumber - startStepNumber, msg]);
        }
        return [recorded];
    };
};

doc(
    "play.messages",
    {
        "messages": "",
    },
    "Plays output of record.messages starting from when the play is engaged"
);
const playMessages = (object) => {
    object.needsTick = true;

    let playlist = [];
    let queue = [];
    let next;
    let playing = false;
    let lastStepNumber = undefined;
    let startStepNumber = undefined;

    const play = () => {
        playing = true;
        startStepNumber = 0; //lastStepNumber;
        queue = [... playlist];
        next = queue.shift();
    };

    return ([msg, ...args]) => {
        switch (msg) {
        case START:
            return;
        case 1:
            if (!playing) {
                play();
            }
            return;
        case 0:
            playing = false;
            return;
        case "play":
            play();
            return;
        case "stop":
            playing = false;
            return;
        case TICK:
            lastStepNumber = object.sequencerEngine.trackStep;
            if (playing && next) {
                let stepNumber = lastStepNumber - startStepNumber;
                if (next[0] <= stepNumber) {
                    let play = next;
                    next = queue.shift();
                    return [play[1]];
                }
            }
            return;
        default:
            playlist = msg;
        }
    };
};

export const record = {
    "play.messages": playMessages,
    "record.messages" : recordMessages
};
